import {OnDestroy, OnInit} from '@angular/core';
import {Component} from '@angular/core';
import {WaTextDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-getting-started-aside',
	templateUrl:'./GettingStartedAsidePage.html',
	styles: [],
	styleUrls:['./GettingStartedAsidePage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		WaTextDirective,
		MarkdownComponent,
],
	standalone:true
})
export class GettingStartedAsidePage
{
	useGradle = false;
	private _storageListener: any;
	private _customListener: any;
	mdContent_490 = `\`\`\`xml
<dependencyManagement>
    <dependencies>
        <dependency>
            <groupId>com.jwebmp</groupId>
            <artifactId>jwebmp-bom</artifactId>
            <version>\${jwebmp.version}</version>
            <type>pom</type>
            <scope>import</scope>
        </dependency>
    </dependencies>
</dependencyManagement>
\`\`\``;
	mdContent_491 = `\`\`\`groovy
dependencies {
    implementation platform(
        "com.jwebmp:jwebmp-bom:$jwebmpVersion"
    )
}
\`\`\``;
	mdContent_492 = `\`\`\`xml
<dependency>
    <groupId>com.jwebmp</groupId>
    <artifactId>jwebmp-core</artifactId>
</dependency>
\`\`\``;
	mdContent_493 = `\`\`\`groovy
dependencies {
    implementation "com.jwebmp:jwebmp-core"
}
\`\`\``;
	mdContent_494 = `\`\`\`java
module my.app {
    requires transitive com.jwebmp.core;
    opens my.app to com.google.guice;
}
\`\`\``;
	ngOnInit() {
	    const saved = localStorage.getItem('jwebmp-build-tool');
	    if (saved) { this.useGradle = saved === 'gradle'; }
	    this._storageListener = (e: StorageEvent) => {
	        if (e.key === 'jwebmp-build-tool') {
	            this.useGradle = e.newValue === 'gradle';
	        }
	    };
	    this._customListener = (e: any) => {
	        this.useGradle = e.detail;
	    };
	    window.addEventListener('storage', this._storageListener);
	    window.addEventListener('jwebmp-build-tool-change', this._customListener);
	}
	ngOnDestroy() {
	    window.removeEventListener('storage', this._storageListener);
	    window.removeEventListener('jwebmp-build-tool-change', this._customListener);
	}

}
